import { useParams, Link } from "react-router-dom"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import Quiz from "../components/Quiz"
import { featuredQuizzes, cpcQuizzes, crcQuizzes, freeSample } from "../content/quizzes"
import useIsMobile from "../hooks/useIsMobile"

export default function SampleQuiz() {
    const { quizId } = useParams()
    const isMobile = useIsMobile()
    const quiz = quizId === "free"
        ? freeSample
        : featuredQuizzes.find((q) => q.id === quizId)
        || cpcQuizzes.find((q) => q.id === quizId)
        || crcQuizzes.find((q) => q.id === quizId)

    return (
        <div style={{ width: "100%", background: "white", fontFamily: "Inter, sans-serif", color: "#111827" }}>
            <Navbar />

            <section style={{ maxWidth: 900, margin: "0 auto", padding: isMobile ? "32px 20px 24px" : "60px 24px 40px" }}>
                <Link to="/" style={{
                    display: "inline-flex", alignItems: "center", gap: 6,
                    color: "#6B7280", textDecoration: "none", fontSize: 15,
                    fontWeight: 500, marginBottom: isMobile ? 20 : 32,
                }}>
                    ← Back to quizzes
                </Link>

                {quiz && (
                    <>
                        <h1 style={{ fontSize: isMobile ? 32 : 52, fontWeight: 800, letterSpacing: "-0.04em", margin: "0 0 12px" }}>
                            {quiz.title}
                        </h1>
                        <p style={{ fontSize: isMobile ? 16 : 18, color: "#6B7280", lineHeight: 1.7, marginBottom: isMobile ? 28 : 40 }}>
                            One question at a time. You'll see your score and explanations at the end.
                        </p>
                    </>
                )}
            </section>

            <section style={{ maxWidth: 900, margin: "0 auto", padding: isMobile ? "0 20px 60px" : "0 24px 80px" }}>
                {quiz ? (
                    <Quiz quiz={quiz} />
                ) : (
                    <div style={{
                        border: "1px solid #E5E7EB", borderRadius: 20,
                        padding: isMobile ? 32 : 56, textAlign: "center",
                        boxShadow: "0 10px 30px rgba(17,24,39,0.05)",
                    }}>
                        <p style={{ fontSize: isMobile ? 18 : 22, color: "#6B7280" }}>
                            Quiz not found. Try one from the home page.
                        </p>
                        <Link to="/" style={{
                            display: "inline-block", marginTop: 24,
                            background: "#2563EB", color: "white",
                            padding: "14px 28px", borderRadius: 12,
                            textDecoration: "none", fontWeight: 700, fontSize: 16,
                        }}>
                            Browse quizzes
                        </Link>
                    </div>
                )}
            </section>

            <Footer />
        </div>
    )
}
